import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=c57c308a&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57c308a",
  null
  
)

export default component.exports